import loadAppNexus from 'shared/banners/appNexus/loadAppNexus.js';

export default function setupAppNexus(eventHub) {
    const appNexus = loadAppNexus();

    window.FINN = window.FINN || {};
    window.FINN.banner = window.FINN.banner || {};
    window.FINN.banner.hub = eventHub; // used in AppNexus.js...
    window.FINN.banner.appNexus = appNexus;
}
